import { SearchScenarioId } from 'owa-search-next-common';
import { action } from 'satcheljs';

const onSearchBoxBlurred = action('ON_SEARCH_BOX_BLURRED_NEXT', (scenarioId: SearchScenarioId) => ({
    scenarioId,
}));

export default onSearchBoxBlurred;
